import { ApiHttpService } from '../ApiHttpService';

const CONFIRMATION_PATH = 'usuario/ValidarPWD';

class PasswordConfirmationController {
  static confirm(password) {
    const authenticated = true;
    return ApiHttpService.post(CONFIRMATION_PATH, {
      PWD: password,
    }, authenticated);
  }
}

export { PasswordConfirmationController };



// WEBPACK FOOTER //
// ./src/networking/controllers/PasswordConfirmationController.js